<!-- Utilizar https://www.ag-grid.com/vue-grid/csv-export/ -->
<template>
  <div>
    <div style="height: 100%">
      <div class="container">
        <div>
          <button
            style="margin-bottom: 5px; font-weight: bold;"
            @click="onBtExport()"
          >
            Export to Excel
          </button>
        </div>
        <div class="grid-wrapper">
          <ag-grid-vue
            id="myGrid"
            style="width: 500px; height: 500px;"
            class="ag-theme-alpine"
            :grid-options="gridOptions"
            :default-col-def="defaultColDef"
            :column-defs="columnDefs"
            :row-data="rowData"
            @grid-ready="onGridReady"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue3'
export default {
  name: 'ExampleTableTest',
  components: {
    'ag-grid-vue': AgGridVue
  },
  data: function () {
    return {
      gridOptions: null,
      gridApi: null,
      columnApi: null,
      columnDefs: null,
      defaultColDef: null,
      rowData: []
    }
  },
  beforeMount () {
    this.gridOptions = {}
    this.columnDefs = [
      {
        headerName: 'Group A',
        children: [
          {
            field: 'athlete',
            minWidth: 200
          },
          {
            field: 'country',
            minWidth: 200
          }
        ]
      },
      {
        headerName: 'Group B',
        children: [
          {
            field: 'sport',
            minWidth: 150
          },
          { field: 'gold' },
          { field: 'silver' },
          { field: 'bronze' },
          { field: 'total' }
        ]
      }
    ]
    this.defaultColDef = {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 100,
      flex: 1
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    this.gridColumnApi = this.gridOptions.columnApi
  },
  methods: {
    onBtExport () {
      this.gridApi.exportDataAsCsv()
    },
    onGridReady (params) {
      const updateData = (data) => {
        this.rowData = data
      }

      fetch('https://www.ag-grid.com/example-assets/small-olympic-winners.json')
        .then((resp) => resp.json())
        .then((data) => updateData(data))
    }
  }
}
</script>
